import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { StorageService } from 'src/app/air/modules/common/service/storage/storage.service';
import { MessageService } from 'primeng/api';
import { SubSink } from 'subsink';
import { AuthService } from 'src/app/air/modules/common/service/auth/auth.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['../auth.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnDestroy {
  private subscription = new SubSink();
  passwordResetForm: FormGroup;
  showConfPassword: boolean | undefined;
  showPassword: boolean | undefined;
  private mytimer: any;
  @ViewChild('code') codeInput : any;
  @ViewChild('password') passwordInput : any;
  @ViewChild('confPassword') confPasswordInput : any;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private storageService: StorageService) {
    this.passwordResetForm = this.formBuilder.group({
      code: ['', [Validators.required, Validators.pattern("^[0-9]+$")]],
      password: ['', [Validators.required,
      Validators.pattern("^(?=.*[A-Z].*[A-Z])(?=.*[a-z].*[a-z])(?=.*[!@#$&*].*[!@#$&*])(?=.*[0-9].*[0-9]).{14,}$")
      ]],
      confPassword: ['', [Validators.required]],
    });
  }


  get code() { return this.passwordResetForm.get('code'); }
  get password() { return this.passwordResetForm.get('password'); }
  get confPassword() { return this.passwordResetForm.get('confPassword'); }

  ngOnInit(): void {
  }

  // resetPassword() {
  //   this.subscription.unsubscribe();
  //   if (this.code.errors && this.code.errors.required) {
  //     this.messageService.add({
  //       key: 'emptyToster',
  //       severity: 'error',
  //       life: 10000,
  //       summary: 'Error Message',
  //       detail: 'Code is required!'
  //     });
  //     this.codeInput.nativeElement.focus();
  //     return;
  //   }
  //   let email = this.storageService.getItem('userEmail');
  //   if (this.password == email) {
  //     this.messageService.add({
  //       key: 'emptyToster',
  //       severity: 'error',
  //       life: 10000,
  //       summary: 'Password Message',
  //       detail: 'Password Cannot be userId'
  //     });
  //     this.passwordInput.nativeElement.focus();
  //     return;
  //   }
  //   if (this.code.errors && this.code.errors.pattern) {
  //     this.messageService.add({
  //       key: 'emptyToster',
  //       severity: 'error',
  //       life: 10000,
  //       summary: 'Error Message',
  //       detail: 'Code must be numeric!'
  //     });
  //     this.codeInput.nativeElement.focus();
  //     return;
  //   }

  //   if (this.code.value.length != 6) {
  //     this.messageService.add({
  //       key: 'emptyToster',
  //       severity: 'error',
  //       life: 10000,
  //       summary: 'Error Message',
  //       detail: 'Code length should be 6 digit!'
  //     });
  //     this.codeInput.nativeElement.focus();
  //     return;
  //   }

  //   if (this.password.errors && this.password.errors.pattern) {
  //     this.messageService.clear()
  //     clearInterval(this.mytimer)
  //     this.messageService.add({
  //       key: 'resetPasswordToaster',
  //       severity: 'error',
  //       sticky: true,
  //       summary: 'Password Message',
  //       // detail: 'Password must contains two capital letter, two small letter, two special character, two numeric character, no blank space and legnth of password must be greater than 14 !'
  //     });
  //     this.passwordInput.nativeElement.focus();
  //     this.mytimer = setInterval(()=>{
  //       if(this.password.valid && (this.confPassword.value == this.password.value)){
  //         this.messageService.clear('resetPasswordToaster')
  //         clearInterval(this.mytimer)
  //     }
  //   },1000)
  //     return;
  //   }

  //   if (this.password.errors && this.password.errors.required) {
  //     this.messageService.add({
  //       key: 'emptyToster',
  //       severity: 'error',
  //       life: 10000,
  //       summary: 'Password Message',
  //       detail: 'Password is required!'
  //     });
  //     this.passwordInput.nativeElement.focus();
  //     return;
  //   }

  //   if (this.confPassword.errors && this.confPassword.errors.required) {
  //     this.messageService.add({
  //       key: 'emptyToster',
  //       severity: 'error',
  //       life: 10000,
  //       summary: 'Password Message',
  //       detail: 'Confirm password is required!'
  //     });
  //     this.confPasswordInput.nativeElement.focus();
  //     return;
  //   }

  //   if (this.confPassword.value != this.password.value) {
  //     this.messageService.add({
  //       key: 'emptyToster',
  //       severity: 'error',
  //       life: 10000,
  //       summary: 'Password Message',
  //       detail: 'Password & confirm password do not match!'
  //     });
  //     this.confPasswordInput.nativeElement.focus();
  //     return;
  //   }
  //   this.authService.resetPasswordWithCode({
  //     email: this.storageService.getItem('userEmail'),
  //     code: this.code.value,
  //     new_password: this.password.value
  //   }).then((res) => {
  //     console.log("success " + res);
  //     this.authService.passwordResendNav();
  //   }).catch((err) => {
  //     this.messageService.add({
  //       key: 'emptyToster',
  //       severity: 'error',
  //       life: 10000,
  //       summary: 'Password Message',
  //       detail: err.message
  //     });
  //     console.log("error " + err)
  //     return;
  //   })
  //   //#region Observable
  //   // this.subscription.add(this.authService.resetPassword({
  //   //   email_id: this.storageService.getItem('userEmail'),
  //   //   code: this.code.value,
  //   //   new_password: this.password.value
  //   // }).subscribe((data: any) => {
  //   //   if (data.status == 200) {
  //   //     if (data.data && data.data.type) {
  //   //       this.messageService.add({
  //   //         key: 'emptyToster',
  //   //         severity: 'error',
  //       // life: 10000,
  //   //         summary: 'Error Message',
  //   //         detail: data.data.message
  //   //       });
  //   //       return;
  //   //     }
  //   //     this.authService.logout();
  //   //   }
  //   // }, (error: any) => {
  //   //   console.log(error);
  //   // }));
  //   //#endregion observable
  // }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
